<template>
    <div class="timeline-add-element">
        <p class="text-center">
            {{ $t('postSurgery.createPopup.description') }}
        </p>
        <b-row class="justify-content-center mb-3">
            <hemocir-button
                ref="transfusionButton"
                :class="{'active': transfusionActive}"
                variant="outline-primary"
                class="mx-3"
                @click="createTransfusion"
            >
                {{ $t('surgery.transfusion.title') }}
                <img v-if="transfusionActive" alt="" src="@/assets/icons/transfusion_icon_white.svg" style="height: 1.8rem;" />
                <img v-else alt="" src="@/assets/icons/transfusion_icon.svg" style="height: 1.8rem;" />
            </hemocir-button>
            <hemocir-button
                :class="{'active': bloodTestActive}"
                variant="outline-primary"
                class="mx-3"
                @click="createBloodTest"
            >
                {{ $t('bloodTest.title') }}
                <img v-if="bloodTestActive" alt="" src="@/assets/icons/analitica_icon_white.svg" style="height: 1.8rem;" />
                <img v-else alt="" src="@/assets/icons/analitica_icon.svg" style="height: 1.8rem;" />
            </hemocir-button>
            <hemocir-button
                :class="{'active': noevoeightActive}"
                variant="outline-primary"
                class="mx-3"
                @click="createNovoeightTreatment"
            >
                {{ $t('surgery.novoeightTreatment') }}
                <img v-if="noevoeightActive" alt="" src="@/assets/icons/novoeight_icon_white.svg" style="height: 1.8rem;" />
                <img v-else alt="" src="@/assets/icons/novoeight_icon.svg" style="height: 1.8rem;" />
            </hemocir-button>
        </b-row>

        <component
            :is="elementComponent"
            :element-data="elementData"
            :is-complication="isComplication"
            class="mt-3 mx-3"
            @close="$emit('close')"
            @save="$emit('save')"
        />
    </div>
</template>

<script>
    import DetailSurgeryTransfusion from "@/components/surgery/detail/elements/DetailSurgeryTransfusion";
    import DetailSurgeryBloodTest from "@/components/surgery/detail/elements/DetailSurgeryBloodTest";
    import DetailSurgeryNovoeight from "@/components/surgery/detail/elements/DetailSurgeryNovoeight";

    export default {
        name: "DetailSurgeryAddElement",
        components: {Transfusion: DetailSurgeryTransfusion},
        props: {
            date: {
                type: String,
                required: true
            },
            surgeryId: {
                type: Number,
                required: true,
            },
            isComplication: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                elementComponent: null,
                elementData: {}
            };
        },
        computed: {
            transfusionActive() {
                return this.elementComponent === DetailSurgeryTransfusion;
            },
            bloodTestActive() {
                return this.elementComponent === DetailSurgeryBloodTest;
            },
            noevoeightActive() {
                return this.elementComponent === DetailSurgeryNovoeight;
            },
        },
        methods: {
            createTransfusion() {
                this.elementData = this.createInitialData();
                this.elementComponent = DetailSurgeryTransfusion;
                this.emitSelected();
            },
            createBloodTest() {
                this.elementData = this.createInitialData();
                this.elementComponent = DetailSurgeryBloodTest;
                this.emitSelected();
            },
            createNovoeightTreatment() {
                this.elementData = this.createInitialData();
                this.elementComponent = DetailSurgeryNovoeight;
                this.emitSelected();
            },
            emitSelected() {
                this.$emit('select');
            },
            createInitialData() {
                return {values: {date: this.date, surgery: this.surgeryId}};
            }
        },
    };
</script>

<style scoped>
</style>